module.exports = __webpack_public_path__ + "static/media/race.a7f07875.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/race.jpg
// module id = 159
// module chunks = 0